import classNames from 'clsx';

import type { HTMLAttributes, PropsWithChildren } from 'react';

import styles from './FormField.module.css';

export interface FormFieldProps extends HTMLAttributes<HTMLDivElement> {
  /** true if a margin at the top and bottom should be added; otherwise, false. The default is false. */
  outerSpace?: boolean;
  /** true if the label and input field should be rendered on the same row; otherwise, false. The default is false. */
  inline?: boolean;
  /** to be used in combination with 'inline'; true if the label and input field should be rendered on start of the same row; otherwise, false. The default is false. */
  alignStart?: boolean;
}

/** Represents an element to wrap a label and input field. */
export const FormField = ({ children, outerSpace, inline, alignStart, ...rest }: PropsWithChildren<FormFieldProps>) => (
  <div
    className={classNames(styles['form-field'], {
      [styles['form-field--outerspace']]: outerSpace,
      [styles['form-field--inline']]: inline,
      [styles['form-field--align-start']]: alignStart,
    })}
    {...rest}
  >
    {children}
  </div>
);
